import { useEffect, useRef, useState } from 'react';
import { CaptureToolbar } from '@overlayqa/shared/ui';
import { WORKFLOW_CARD_DESCRIPTIONS, WORKFLOW_CARD_LABELS } from '@overlayqa/shared';

/** The six workflows the product offers, from the same shared names and descriptions every surface lists. */
const WORKFLOWS = Object.keys(WORKFLOW_CARD_DESCRIPTIONS).map(id => ({ id, label: WORKFLOW_CARD_LABELS[id], description: WORKFLOW_CARD_DESCRIPTIONS[id] }));

/** The product renderer, including real icon states, drag behavior and tooltips. */
export function CaptureToolbarExample() {
  const [inspector, setInspector] = useState(true);
  const [capturing, setCapturing] = useState(true);
  const [paused, setPaused] = useState(false);
  const [mode, setMode] = useState<'select' | 'screenshot'>('select');
  const [pinsVisible, setPinsVisible] = useState(true);
  const [boxesVisible, setBoxesVisible] = useState(true);
  const highlightsVisible = pinsVisible || boxesVisible;
  const toggleHighlights = () => { setPinsVisible(!highlightsVisible); setBoxesVisible(!highlightsVisible); };
  const spacing = useRef(false);
  useEffect(() => {
    const announce = () => window.dispatchEvent(new CustomEvent('oq:spacing-state', { detail: { enabled: spacing.current } }));
    const toggle = () => { spacing.current = !spacing.current; announce(); };
    const disable = () => { spacing.current = false; announce(); };
    const escape = (event: KeyboardEvent) => {
      const target = event.composedPath()[0];
      if (event.key === 'Escape' && !(target instanceof Element && target.closest('input,textarea,select,[contenteditable]'))) disable();
    };
    window.addEventListener('oq:spacing-toggle', toggle);
    window.addEventListener('oq:spacing-query', announce);
    window.addEventListener('oq:spacing-disable', disable);
    window.addEventListener('keydown', escape, true);
    announce();
    return () => {
      window.removeEventListener('oq:spacing-toggle', toggle);
      window.removeEventListener('oq:spacing-query', announce);
      window.removeEventListener('oq:spacing-disable', disable);
      window.removeEventListener('keydown', escape, true);
    };
  }, []);
  return <div style={{ width: '100%', minHeight: 'calc(var(--oq-space-12) * 4)', position: 'relative' }}>
    <button type="button" className="oq-btn oq-btn--secondary oq-btn--toolbar" onClick={() => { setCapturing(true); setPaused(false); }}><span className="text-cap-trim block">Start capture</span></button>
    <CaptureToolbar inspector={{ enabled: inspector, onChange: setInspector }} mode={capturing ? mode : 'idle'} position="absolute" isPaused={paused} count={3}
      tools={{ selectLabel: 'Create · C', screenshotLabel: 'Screenshot · S', onSelect: () => setMode('select'), onScreenshot: () => setMode('screenshot') }}
      workflows={{ items: WORKFLOWS, onSelect: () => {} }}
      highlights={{ visible: highlightsVisible, label: `${highlightsVisible ? 'Hide' : 'Show'} highlights on page · V`, onToggle: toggleHighlights,
        layers: { pins: { visible: pinsVisible, count: 3, onToggle: setPinsVisible }, boxes: { visible: boxesVisible, count: 3, onToggle: setBoxesVisible } } }}
      onTogglePause={() => setPaused(value => !value)} onDone={() => setCapturing(false)} />
  </div>;
}
